import React, { useState } from 'react'
// libs
import styled from 'styled-components'
// components
import Title from 'components/UI/Typography'
import Tooltip from '@mui/material/Tooltip'
import Toolbar from '@mui/material/Toolbar'
import IconButton from '@mui/material/IconButton'
import FilterListIcon from '@mui/icons-material/FilterList'
// themes
import { colors } from 'themes/index'

const FilterIcon = styled(({ isActive, ...rest }) => <FilterListIcon {...rest} />)`
  color: ${({ isActive }) => (isActive ? colors.blue300 : 'inherit')};
`

interface Props {
  title: string
  children?: React.ReactNode
}

const TableTitle: React.FC<Props> = ({ title, children }) => {
  const [isShown, setIsShown] = useState(false)

  return (
    <>
      <Toolbar style={{ paddingLeft: '16px' }}>
        <div>
          <Title>{title}</Title>
        </div>
        {children && (
          <div>
            <Tooltip title='Filter list'>
              <IconButton aria-label='Filter list' onClick={() => setIsShown(!isShown)} size='large'>
                <FilterIcon isActive={isShown} />
              </IconButton>
            </Tooltip>
          </div>
        )}
      </Toolbar>
      {isShown && <Toolbar>{children}</Toolbar>}
    </>
  )
}

export default TableTitle
